import * as qualityAssuranceApi from '../../api/qualityAssuranceApi'

const state = {
	qualityAssurance: {
		PartName: null,
		PartNo: null,
		MobilePhone: null,
		Imei: null,
		StoreSysNo: null
	},
	storeDataList: []
}

const actions = {
	// 提交质保
	async addQualityAssurance({
		commit
	}, qualityAssurance) {
		const response = await qualityAssuranceApi.addQualityAssurance(qualityAssurance);
		return response;
	},
	async getStoreList({
		commit
	}) {
		const response = await qualityAssuranceApi.getStoreList();
		commit('setStoreList', response);
	},
	clearState({commit}){
		commit('clearState');
	},
	async verifyOneCode({commit}, oneCode){
		const response = await qualityAssuranceApi.verifyOneCode(oneCode);
		commit('verifyOneCode',response);
		return response;
	}
}

const mutations = {
	setStoreList(state, res) {
		if (res && res.Status) { // 提交成功
			state.storeDataList = res.Data;
		}
	},
	clearState (state){
		state.qualityAssurance = {};
		state.storeDataList = [];
	},
	verifyOneCode(state, res)
	{
		if (res && res.Status) { 
			if(!!res.Data.ProductName)
			{
				state.qualityAssurance.PartName = res.Data.ProductName;
			}
		}
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/qualityAssuranceAdd.js